export enum ValidationResultType {
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR = 'error',
    FAIL = 'fail',
    UNKNOW = 'unknow',
}

export interface ValidatorMapResult {
    [name: string]: ValidatorObservableSubject
}

export interface ValidatorObservableSubject {
    type: ValidationResultType
    message?: string
}

export interface ValidatorObservableSubjectContextualized {
    name: string
    result: ValidatorObservableSubject
}
